import React from "react";
import {Box, CssBaseline, Link, Stack, ThemeProvider, Typography, useMediaQuery} from "@mui/material";
import {lightTheme} from "./Themes.js";
import fechas_background from "./images/_DSC0039_bw_fade.jpg"
import logo_ull from "./images/logo_ull.svg"
import logo_ayto from "./images/patrocinadores/sponsor/logo_ayto_lalaguna.png"
import skyline from "./images/skyline.svg"
import {globalMaxWidth} from "./GlobalConfigs";
import {Portada} from "./components/Portada";
import {TopBar} from "./components/TopBar";
import {NavigationMenu} from "./components/NavigationMenu";
import {BottomBanner} from "./components/BottomBanner";
import {FechasImportantes} from "./components/FechasImportantes";
import {Novedades} from "./components/Novedades";


function Invitation() {
    return (<Stack direction={{md: 'row', sm: 'column-reverse'}}
                   justifyContent='space-between'
                   alignItems='center'
                   spacing={4}
                   id='presentacion'
                   sx={{
                       width: 1, maxWidth: globalMaxWidth, p: {lg: 8, xs: 4}
                   }}
    >
        <Link href="https://www.ull.es" target="_blank" rel="noopener noreferrer">
            <Box component='img'
                 sx={{
                     height: "125px",
                     cursor: 'pointer',
                     transition: 'all 0.4s ease',
                     '&:hover': {
                         transform: 'scale(1.05)'
                     }
                 }}
                 src={logo_ull}
                 alt={"Logo ULL"}
                 loading="lazy"/>
        </Link>
        <Stack direction='column' spacing={3} sx={{flex: 1}}>
            <Typography variant='h4' sx={{fontWeight: 700, color: 'primary.main', letterSpacing: 1}}>
                Bienvenida e Invitación
            </Typography>
            <Typography variant='body1' align='justify'>
                La Universidad de la Laguna le invita a la XLI edición del Simposio Nacional de la Unión Científica
                Internacional de Radio, URSI 2026, que se celebrará en La Laguna, Tenerife <Box component='span' sx={{color: 'primary.main', fontWeight: 'bold'}}>del 2 al 4 de septiembre de 2026</Box>.

            </Typography>

            <Typography variant='body1' align='justify'>
                Desde 1980 la URSI es el foro de técnico de referencia de investigadores, empresas y tecnólogos del
                sector TIC y el principal evento anual del Comité Nacional Español de URSI <Link
                href='www.ursi.es'><strong>www.ursi.es</strong></Link>.
                Reúne anualmente investigadores, profesionales y estudiantes del ámbito de las Tecnologías de la
                Información
                y las Comunicaciones, para presentar sus trabajos de investigación y desarrollo tecnológico.
            </Typography>

            <Typography variant='body1' align='justify'>
                Además de ser una excelente oportunidad para los investigadores noveles, el congreso es una plataforma
                para debatir, intercambiar experiencias y abrir posibilidades de colaboración entre los distintos grupos
                de trabajo existentes en áreas TIC de la ingeniería y de las ciencias experimentales y de ellos con la
                industria.
            </Typography>
        </Stack>
    </Stack>)
}

function LaLagunaSection() {
    return (
        <Box sx={{width: 1, display: 'flex', justifyContent: 'center', backgroundColor: '#fdfdfd'}}>
            <Stack direction={{md: 'row', xs: 'column'}}
                   justifyContent='space-between'
                   alignItems='center'
                   spacing={6}
                   sx={{
                       width: 1, maxWidth: globalMaxWidth, p: {lg: 8, xs: 4}
                   }}
            >
                <Stack direction='column' spacing={3} sx={{flex: 1}}>
                    <Typography variant='h4' sx={{fontWeight: 700, color: 'primary.main', letterSpacing: 1}}>
                        San Cristóbal de La Laguna
                    </Typography>
                    <Typography variant='h6' sx={{fontWeight: 600, color: 'text.secondary', mt: -2}}>
                        Ciudad Patrimonio de la Humanidad y Sede Universitaria
                    </Typography>
                    <Typography variant='body1' align='justify' sx={{lineHeight: 1.8}}>
                        Declarada Patrimonio de la Humanidad por la UNESCO en 1999, La Laguna destaca por su trazado urbano del siglo XVI, que se mantiene prácticamente intacto. Antigua capital de la isla, hoy es un vibrante centro cultural y universitario donde edificios monumentales y casas señoriales conviven con una moderna oferta comercial y gastronómica. Situada en el Valle de Aguere, fusiona su legado histórico con la riqueza natural del Parque Rural de Anaga y la serenidad de sus piscinas naturales en Bajamar y Punta del Hidalgo.
                    </Typography>
                </Stack>
                <Link href="https://www.aytolalaguna.es" target="_blank" rel="noopener noreferrer">
                    <Box component='img'
                         sx={{
                             width: {md: "225px", xs: "150px"},
                             height: "auto",
                             filter: "grayscale(100%)",
                             opacity: 0.8,
                             transition: 'all 0.4s ease',
                             cursor: 'pointer',
                             '&:hover': {
                                 filter: 'grayscale(0%)',
                                 opacity: 1,
                                 transform: 'scale(1.05)'
                             }
                         }}
                         src={logo_ayto}
                         alt={"Logo Ayuntamiento de La Laguna"}
                         loading="lazy"/>
                </Link>
            </Stack>
        </Box>
    )
}

function FechasImportantesWrapped() {
    return (
        <Box
            id='fechas'
            sx={{
                width: 1,
                backgroundImage: `url(${skyline}), url(${fechas_background})`,
                backgroundSize: {x5l: '40%, 40%', x3l: '40%, 60%', x2l: '40%, 75%', lg: '40%, 100%', sm: '65%, 100%', xs: '65%, 100%'},
                backgroundRepeat: 'no-repeat, no-repeat',
                backgroundPosition: 'bottom -1px left, bottom right',
                backgroundOrigin: 'border-box'
            }}>
            <Stack sx={{
                height: 1,
                pr: {lg: 25, xs: 5},
                pb: {lg: 25, xs: 15},
                pl: {lg: 5, xs: 2},
                pt: 5
            }}>
                <FechasImportantes/>
            </Stack>
        </Box>
    )
}

function HomePage() {
    return (<ThemeProvider theme={lightTheme}>
        <div className="App">
            <CssBaseline/>
            {/*<UnderConstructionPage/>*/}
            <Stack alignItems='center' spacing={0}>
                <TopBar/>
                <NavigationMenu/>
                <Portada/>
                <Invitation/>
                <LaLagunaSection/>
                <Novedades/>
                <FechasImportantesWrapped/>
                <BottomBanner/>
            </Stack>
        </div>
    </ThemeProvider>);
}

export default HomePage;
